var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _vm.isDisplayingQrcodeScanner ? _c('div', {
    staticClass: "scanner-view"
  }, [_c('div', {
    staticClass: "scanner-view__body"
  }, [_c('div', {
    staticClass: "scanner-view__title mb-3"
  }, [_vm._v("請將 QR code 對準框線")]), _c('QRCodeScanner', {
    ref: "qrScanner",
    staticClass: "scanner-view__scanner",
    attrs: {
      "qrbox": _vm.qrbox
    },
    on: {
      "onScan": _vm.handleQrCodeIsScanned
    }
  }), _c('button', {
    staticClass: "scanner-view__close s-btn s-btn-outline-primary s-btn-xs mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCloseScannerButtonIsClicked
    }
  }, [_vm._v(" 取消 ")])], 1)]) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "content",
    style: _vm.colors
  }, [_c('div', {
    staticClass: "custom-elanco-header"
  }, [_c('span', {
    staticClass: "custom-elanco-header__text"
  }, [_vm._v("Hi " + _vm._s(_vm.deepGet(_vm.user, 'name')))]), _c('a', {
    attrs: {
      "href": _vm.deepGet(_vm.event, 'config.header_logo_url', '#')
    }
  }, [_vm.deepGet(_vm.event, 'config.images.header_logo') ? _c('img', {
    staticClass: "custom-elanco-header__image ml-3",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.header_logo')
    }
  }) : _vm._e()])]), _vm.page === 'redeem' ? _c('div', [_vm.deepGet(_vm.event, 'config.images.redeem_confirm_kv') ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.redeem_confirm_kv'),
      "alt": "Elanco"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "py-3 px-4"
  }, [_vm.deepGet(_vm.event, 'config.redeem_notes_top') ? _c('div', {
    staticClass: "redeem-notes redeem-notes--top mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.event, 'config.redeem_notes_top'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "card__info"
  }, [_c('ShopSelection', {
    ref: "shopSelection",
    attrs: {
      "disabled": _vm.isLoading || !_vm.branchProvider || _vm.isRedeemSuccess || _vm.hasError || _vm.isOverMaxRedeemCount,
      "branch-provider": _vm.branchProvider || '',
      "show-branch-code": false,
      "placeholder": '請選擇獸醫院'
    },
    on: {
      "selected": _vm.handleBranchIsSelected
    },
    model: {
      value: _vm.branchId,
      callback: function callback($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  })], 1), _c('div', {
    staticClass: "card__info"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.branchCode,
      expression: "branchCode"
    }],
    staticClass: "form-control-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.deepGet(_vm.event, 'config.branch_placeholder', '請輸入分店代碼'),
      "disabled": _vm.isRedeemSuccess || _vm.hasError || _vm.isOverMaxRedeemCount
    },
    domProps: {
      "value": _vm.branchCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.branchCode = $event.target.value;
      }
    }
  })]), _vm.deepGet(_vm.event, 'config.redeem_notes_bottom') ? _c('div', {
    staticClass: "redeem-notes redeem-notes--bottom mt-3",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.event, 'config.redeem_notes_bottom'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "btn-container btn-container--redeem"
  }, [_c('button', {
    staticClass: "s-btn s-btn-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading || _vm.isRedeemSuccess || _vm.isOverMaxRedeemCount || !_vm.branchId && !_vm.branchCode
    },
    on: {
      "click": _vm.redeem
    }
  }, [_vm._v(" 確定送出 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mt-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToPointsProgress
    }
  }, [_vm._v(" 查看集點進度 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mt-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToCouponList
    }
  }, [_vm._v(" 查看回饋詳情 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mt-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToElancoIntro
    }
  }, [_vm._v(" 查看活動辦法 ")])])])]) : _vm._e(), _vm.page === 'redeem_success' ? _c('div', {
    staticClass: "content__success"
  }, [_vm.deepGet(_vm.event, 'config.images.redeem_success') ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.redeem_success'),
      "alt": "Elanco"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "py-3 px-4"
  }, [_c('div', {
    staticClass: "content__success__messages"
  }, [_vm.redeemSuccessTitleMessage ? _c('div', {
    staticClass: "text-center py-2 content__success__title",
    domProps: {
      "innerHTML": _vm._s(_vm.redeemSuccessTitleMessage)
    }
  }) : _vm._e()]), _vm.deepGet(_vm.event, 'config.general_redeem_success_message', '') ? _c('div', {
    staticClass: "text-center py-2 mt-4 content__success__title content__success__general-message",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.event, 'config.general_redeem_success_message', ''))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "content__sub_success__messages"
  }, [_vm.redeemSuccessSubTitleMessage ? _c('div', {
    staticClass: "text-center py-2 content__success__sub__title",
    domProps: {
      "innerHTML": _vm._s(_vm.redeemSuccessSubTitleMessage)
    }
  }) : _vm._e()])])]) : _vm._e(), _vm.page === 'redeem_success' ? _c('div', {
    staticClass: "py-3 px-4"
  }, [_c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mb-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToPointsProgress
    }
  }, [_vm._v(" 查看集點進度 ")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToCouponList
    }
  }, [_vm._v(" 查看回饋詳情 ")])]) : _vm._e(), _vm.page === 'card' ? _c('div', {
    staticClass: "content__card d-flex flex-column content__card__bg"
  }, [_c('div', {
    staticClass: "content__card__level py-3 d-flex justify-content-center"
  }, [_c('img', {
    staticClass: "mx-2 img-fluid",
    attrs: {
      "src": _vm.redeemCycleImage
    }
  })]), _c('div', {
    staticClass: "content__card__remaining text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.redeemCycleMessage)
    }
  }), _c('div', {
    staticClass: "content__card__buttons py-3"
  }, [_c('button', {
    staticClass: "btn btn-link my-1 mx-2",
    on: {
      "click": _vm.handleOpenScannerButtonIsClicked
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/2026/card-btn-1.png")
    }
  })]), _vm.shouldShowMgmButton ? _c('button', {
    staticClass: "btn btn-link my-1 mx-2",
    on: {
      "click": _vm.handleShareButtonIsClicked
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/2026/card-btn-2.png")
    }
  })]) : _vm._e(), _c('button', {
    staticClass: "btn btn-link my-1 mx-2",
    on: {
      "click": _vm.goToCouponList
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/2026/card-btn-3.png")
    }
  })])])]) : _vm._e(), _vm.page === 'empty_message' ? _c('div', [_vm._m(0), _c('div', {
    staticClass: "btn-container"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" 返回上一頁 ")])])]) : _vm._e()])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "alert-message"
  }, [_vm._v(" 網址錯誤，沒有活動代碼或序號 ")])]);
}]

export { render, staticRenderFns }